import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { LoadingPage } from '../../../_commons/Utils/React/Components/Pages/LoadingPage';
import { CourseService } from '../../../_services/radacad-academy-lms/CourseService';


interface IPaymentProduct {
    productId: number;
    productName: string;
    slug: string;
    purchaseUrl: string;
    photoUrl: string;
}

export default function PurchaseCourseCards(props: { courseId: number }) {
    const { courseId } = props;
    const classes = useStyles();
    const [_products, setProducts] = useState<IPaymentProduct[] | undefined | null>(undefined);


    useEffect(() => {
        CourseService.GetProductByCourseId(courseId.toString()).then((products) => {
            setProducts(products)
        }).catch(() => { setProducts(null) });

    }, [courseId])


    return <div className={classes.container}>

        {
            _products === undefined ? (
                <LoadingPage />
            ) : _products === null || _products.length === 0 ? (
                <div className={classes.messageDiv}>
                    <h3>Access Required</h3>
                    <p>You don't have access to this course. Please contact support to purchase access.</p>
                </div>
            ) : (
                <div className={classes.accessMessage}>

                    <div className={classes.productsGrid}>
                        {_products.map((product) => (
                            <div key={product.productId} className={classes.productCard}>
                                <a 
                                    href={product.purchaseUrl} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className={classes.productLink}
                                >
                                    <h3>{product.productName}</h3>
                                    {product.photoUrl && (
                                        <img 
                                            src={product.photoUrl} 
                                            alt={product.productName}
                                            className={classes.productImage}
                                        />
                                    )}
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            )
        }
    </div>


}
const useStyles = makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        minHeight: '300px',
    },
    messageDiv: {
        textAlign: 'center',
        padding: '30px',
        border: '2px solid #666',
        borderRadius: '8px',
        backgroundColor: '#1a1a1a',
        '& h3': {
            color: '#ff9800',
            marginBottom: '10px',
        },
        '& p': {
            fontSize: '16px',
        }
    },
    accessMessage: {
        width: '100%',
        textAlign: 'center',
        '& h2': {
            color: '#ff9800',
            marginBottom: '10px',
        },
        '& p': {
            fontSize: '16px',
            marginBottom: '30px',
        }
    },
    productsGrid: {
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap',
        gap: '20px',
    },
    productCard: {
        width: '30%',
        minWidth: '300px',
        padding: '2%',
    },
    productLink: {
        display: 'block',
        padding: '5%',
        borderRadius: '5px',
        height: '100%',
        backdropFilter: 'blur(10px)',
        boxShadow: '4px 4px 8px 4px rgba(255,255,255,0.2)',
        transition: '0.3s',
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
            boxShadow: '8px 8px 16px 8px rgba(255,255,255,0.4)'
        },
        '& h3': {
            marginBottom: '15px',
        }
    },
    productImage: {
        width: '100%',
        borderRadius: '5px',
    }
})




